import { render, staticRenderFns } from "./voiceForm.vue?vue&type=template&id=1d1faddc&scoped=true"
import script from "./voiceForm.vue?vue&type=script&lang=js"
export * from "./voiceForm.vue?vue&type=script&lang=js"
import style0 from "./voiceForm.vue?vue&type=style&index=0&id=1d1faddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1faddc",
  null
  
)

export default component.exports